import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { SplitFlapQuote } from '../components/SplitFlapQuote';
import { ArrowRightIcon, HeartIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
export function FreeResourcesPage() {
  return <div className="min-h-screen bg-white pt-24 pb-24" data-id="element-984">
      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden bg-gradient-to-b from-blush-50 to-white" data-id="element-985">
        <SparkleEffect count={80} data-id="element-986" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-987">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-700 mb-6" data-id="element-988">
            Trippin' Through <span className="text-cta-500" data-id="element-989">Guidance</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-plum-500 font-medium" data-id="element-990">
            Tools, support, and a gentle reminder that you don't have to figure
            it all out alone.
          </motion.p>
        </div>
      </section>

      {/* SPARKLY QUOTE MARQUEE */}
      <SplitFlapQuote data-id="element-991" />

      {/* REDESIGNED CRISIS SECTION */}
      <section className="py-16 bg-gradient-to-br from-lavender-50 via-blush-50 to-pink-50 relative overflow-hidden" data-id="element-992">
        <SparkleEffect count={40} data-id="element-993" />

        {/* Decorative blurred circles for soft glow */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-994" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-100/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3 pointer-events-none" data-id="element-995" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-996">
          <div className="text-center mb-12" data-id="element-997">
            <GlitterHeart size={40} variant="light" className="mx-auto mb-4" data-id="element-998" />
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-plum-700 mb-3" data-id="element-999">
              If You're Not Okay Right Now
            </h2>
            <p className="text-plum-600 text-lg font-medium max-w-2xl mx-auto" data-id="element-1000">
              You're not alone. You don't have to go through this by yourself.
            </p>
          </div>

          {/* IMMEDIATE CRISIS HELP */}
          <div className="mb-12" data-id="element-1001">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-1002">
              <span className="text-2xl" data-id="element-1003">🚨</span> Immediate Crisis Help
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1004">
              {/* Card 1: Lifeline */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1005">
                <div className="flex items-center gap-3 mb-4" data-id="element-1006">
                  <div className="w-10 h-10 rounded-full bg-sky-50 flex items-center justify-center shrink-0" data-id="element-1007">
                    <PhoneIcon className="w-5 h-5 text-sky-500" data-id="element-1008" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1009">
                    Suicide & Crisis Lifeline
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1010">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1011">Call or text</p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-1012">
                    988
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5 mb-1" data-id="element-1013">
                    <span className="text-cta-400" data-id="element-1014">Chat:</span> 988lifeline.org
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1015">
                    <span data-id="element-1016">🕒</span> Available 24/7, free & confidential
                  </p>
                </div>
                <a href="https://988lifeline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-sky-50 text-sky-600 hover:bg-sky-100 font-bold transition-colors mt-auto" data-id="element-1017">
                  Get Help Now <ArrowRightIcon className="w-4 h-4" data-id="element-1018" />
                </a>
              </div>

              {/* Card 2: Text Line */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1019">
                <div className="flex items-center gap-3 mb-4" data-id="element-1020">
                  <div className="w-10 h-10 rounded-full bg-cta-50 flex items-center justify-center shrink-0" data-id="element-1021">
                    <MessageCircleIcon className="w-5 h-5 text-cta-500" data-id="element-1022" />
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1023">
                    Crisis Text Line
                  </h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1024">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1025">
                    Text <strong className="text-plum-800" data-id="element-1026">HOME</strong> to
                  </p>
                  <p className="text-4xl font-black text-plum-800 mb-3 tracking-tight" data-id="element-1027">
                    741741
                  </p>
                  <p className="text-plum-500 text-sm font-medium mb-1" data-id="element-1028">
                    Connects you with a trained crisis counselor
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1029">
                    <span data-id="element-1030">🕒</span> Available 24/7
                  </p>
                </div>
                <a href="https://www.crisistextline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-cta-50 text-cta-600 hover:bg-cta-100 font-bold transition-colors mt-auto" data-id="element-1031">
                  Talk to Someone <ArrowRightIcon className="w-4 h-4" data-id="element-1032" />
                </a>
              </div>

              {/* Card 3: Emergency */}
              <div className="bg-white rounded-3xl p-6 shadow-md border border-blush-100 flex flex-col h-full" data-id="element-1033">
                <div className="flex items-center gap-3 mb-4" data-id="element-1034">
                  <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center shrink-0" data-id="element-1035">
                    <span className="text-xl" data-id="element-1036">🚓</span>
                  </div>
                  <h4 className="font-bold text-plum-800 text-lg" data-id="element-1037">Emergency</h4>
                </div>
                <div className="mb-4 flex-grow" data-id="element-1038">
                  <p className="text-plum-600 font-medium mb-1" data-id="element-1039">Call</p>
                  <p className="text-4xl font-black text-red-500 mb-3 tracking-tight" data-id="element-1040">
                    911
                  </p>
                  <p className="text-plum-500 text-sm font-medium" data-id="element-1041">
                    If someone is in immediate danger
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* SPECIALIZED SUPPORT */}
          <div className="mb-8" data-id="element-1042">
            <h3 className="font-heading text-xl font-bold text-plum-700 mb-6 flex items-center gap-2" data-id="element-1043">
              <span className="text-2xl" data-id="element-1044">💖</span> Specialized Support
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1045">
              {/* Trevor Project */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1046">
                <div className="flex items-center gap-3 mb-3" data-id="element-1047">
                  <span className="text-2xl" data-id="element-1048">🌈</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1049">LGBTQ+ Support</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1050">
                  The Trevor Project
                </p>
                <div className="space-y-2 mb-4" data-id="element-1051">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1052">
                    1-866-488-7386
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1053">
                    Text <strong className="text-plum-800" data-id="element-1054">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-1055">678678</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1056">
                    <span data-id="element-1057">🕒</span> 24/7 support for LGBTQ+ youth
                  </p>
                </div>
                <a href="https://www.thetrevorproject.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1058">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-1059" />
                </a>
              </div>

              {/* SAMHSA */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1060">
                <div className="flex items-center gap-3 mb-3" data-id="element-1061">
                  <span className="text-2xl" data-id="element-1062">🧠</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1063">
                    Mental Health & Substance Use
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1064">
                  SAMHSA National Helpline
                </p>
                <div className="space-y-2" data-id="element-1065">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1066">
                    1-800-662-4357
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1067">
                    <span data-id="element-1068">🕒</span> 24/7, free, confidential
                  </p>
                </div>
              </div>

              {/* Postpartum */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1069">
                <div className="flex items-center gap-3 mb-3" data-id="element-1070">
                  <span className="text-2xl" data-id="element-1071">👩‍👧</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1072">
                    Postpartum Support
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1073">
                  For Moms (EN/ES)
                </p>
                <div className="space-y-2 mb-4" data-id="element-1074">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1075">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1076">
                    1-800-944-4773
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1077">
                    <span data-id="element-1078">🕒</span> Not 24/7, but very responsive
                  </p>
                </div>
                <a href="https://www.postpartum.net/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1079">
                  Visit Website <ArrowRightIcon className="w-3 h-3" data-id="element-1080" />
                </a>
              </div>

              {/* Domestic Violence */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1081">
                <div className="flex items-center gap-3 mb-3" data-id="element-1082">
                  <span className="text-2xl" data-id="element-1083">💔</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1084">Domestic Violence</h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1085">
                  National Hotline
                </p>
                <div className="space-y-2 mb-4" data-id="element-1086">
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1087">
                    1-800-799-7233
                  </p>
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1088">
                    Text <strong className="text-plum-800" data-id="element-1089">START</strong> to{' '}
                    <strong className="text-plum-800" data-id="element-1090">88788</strong>
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1091">
                    <span data-id="element-1092">🕒</span> 24/7
                  </p>
                </div>
                <a href="https://www.thehotline.org/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-sm gap-1 text-cta-500 hover:text-cta-600 font-bold transition-colors" data-id="element-1093">
                  Get Support <ArrowRightIcon className="w-3 h-3" data-id="element-1094" />
                </a>
              </div>

              {/* Child Abuse */}
              <div className="bg-white rounded-3xl p-6 shadow-sm border border-blush-100" data-id="element-1095">
                <div className="flex items-center gap-3 mb-3" data-id="element-1096">
                  <span className="text-2xl" data-id="element-1097">👶</span>
                  <h4 className="font-bold text-plum-800" data-id="element-1098">
                    Child Abuse Hotline
                  </h4>
                </div>
                <p className="text-plum-500 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-1099">
                  Childhelp
                </p>
                <div className="space-y-2" data-id="element-1100">
                  <p className="text-plum-600 text-sm font-medium" data-id="element-1101">
                    Call or text:
                  </p>
                  <p className="text-plum-700 font-bold text-lg" data-id="element-1102">
                    1-800-422-4453
                  </p>
                  <p className="text-plum-500 text-sm font-medium flex items-center gap-1.5" data-id="element-1103">
                    <span data-id="element-1104">🕒</span> 24/7
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-center text-plum-500 font-medium italic mt-12" data-id="element-1105">
            Take a breath. You're going to be okay. 💗
          </p>
        </div>
      </section>

      {/* SECOND MARQUEE - extra positivity */}
      <SplitFlapQuote data-id="element-1106" />

      {/* FREE RESOURCES SECTION */}
      <section className="py-16 bg-white relative overflow-hidden" data-id="element-1107">
        <SparkleEffect count={60} data-id="element-1108" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1109">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1110">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-plum-700 mb-6" data-id="element-1111">
              Free Resources & Reset
            </h2>
            <p className="text-lg text-plum-600 font-medium leading-relaxed" data-id="element-1112">
              I've been through some really hard things in life—and I know what
              it feels like to feel stuck, overwhelmed, or alone. If that's
              where you are right now, please know this:{' '}
              <strong className="text-plum-800" data-id="element-1113">
                you matter, and you don't have to figure it all out by yourself.
              </strong>
            </p>
          </div>

          {/* Free Coaching Call - thin wide card above the grid */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-10" data-id="element-1114">
            <a href="https://calendly.com/trippinwithmandy/crisis-call" target="_blank" rel="noopener noreferrer" className="flex flex-col sm:flex-row items-center justify-between gap-4 bg-gradient-to-r from-cta-50 to-pink-50 rounded-2xl px-8 py-5 border-2 border-cta-200 shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all" data-id="element-1115">
              <div className="flex items-center gap-4" data-id="element-1116">
                <span className="text-3xl" data-id="element-1117">💗</span>
                <div data-id="element-1118">
                  <h3 className="font-heading text-lg font-bold text-plum-800" data-id="element-1119">
                    Need Someone to Talk To?
                  </h3>
                  <p className="text-plum-500 font-medium text-sm" data-id="element-1120">
                    Book a free coaching call — no strings, no judgment, just
                    support.
                  </p>
                </div>
              </div>
              <span className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 shrink-0" data-id="element-1121">
                Book a Free Call
                <ArrowRightIcon className="w-4 h-4" data-id="element-1122" />
              </span>
            </a>
          </motion.div>

          {/* GRID ROW 1 */}
          <div id="free-lists" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-8 scroll-mt-32" data-id="element-1123">
            {/* Interactive Cleaning Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-cta-50 to-white rounded-3xl p-8 border-2 border-cta-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1124">
              <div className="absolute top-4 right-4 bg-cta-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1125">
                NEW ✨
              </div>
              <div className="text-3xl mb-4" data-id="element-1126">✨</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-1127">
                Free Interactive Cleaning Schedule
              </h3>
              <p className="text-plum-600 font-medium mb-8 flex-grow" data-id="element-1128">
                The Ultimate Cleaning Schedule — what to clean & when. Check
                things off, track your progress, use it every week for free!
              </p>
              <Link to="/free-resources/cleaning-schedule" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-cta-500 text-white font-bold text-sm hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/20 w-full" data-id="element-1129">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-1130" />
              </Link>
            </motion.div>

            {/* Interactive Self-Care Schedule Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-gradient-to-br from-pink-50 to-white rounded-3xl p-8 border-2 border-pink-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1131">
              <div className="absolute top-4 right-4 bg-pink-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1132">
                NEW 🧖‍♀️
              </div>
              <div className="text-3xl mb-4" data-id="element-1133">🧖‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-pink-800 mb-4" data-id="element-1134">
                Free Interactive Self-Care Checklist
              </h3>
              <p className="text-pink-600 font-medium mb-8 flex-grow" data-id="element-1135">
                Daily hygiene and wellness ritual. Take care of your body and
                mind with this simple, trackable daily routine!
              </p>
              <Link to="/free-resources/self-care/daily" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-pink-500 text-white font-bold text-sm hover:bg-pink-600 transition-colors shadow-lg shadow-pink-500/20 w-full" data-id="element-1136">
                Try It Now
                <ArrowRightIcon className="w-4 h-4" data-id="element-1137" />
              </Link>
            </motion.div>

            {/* FREE WORKOUT CONSULTATION Card */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.15
          }} className="bg-gradient-to-br from-sky-50 to-lavender-50 rounded-3xl p-8 border-2 border-sky-200 shadow-md flex flex-col relative overflow-hidden" data-id="element-1138">
              <div className="absolute top-4 right-4 bg-sky-500 text-white text-xs font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-1139">
                FREE 💪
              </div>
              <div className="text-3xl mb-4" data-id="element-1140">💪</div>
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-4" data-id="element-1141">
                Free Workout Consultation
              </h3>
              <p className="text-plum-600 font-medium mb-3 flex-grow" data-id="element-1142">
                Meet Jake — once the smallest in the room, now lifting over 500
                lbs and training for championship-level competition. His journey
                is proof of what consistency and discipline can do.
              </p>
              <p className="text-plum-500 text-sm font-medium mb-6" data-id="element-1143">
                Free consultations, zero pressure — just real advice from
                someone who's been exactly where you are.
              </p>
              <a href="https://calendly.com/trippinwithmandy/jakes-free-workout-consultation" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-sky-500 text-white font-bold text-sm hover:bg-sky-600 transition-colors shadow-lg shadow-sky-500/20 w-full" data-id="element-1144">
                Book Free Consultation
                <ArrowRightIcon className="w-4 h-4" data-id="element-1145" />
              </a>
            </motion.div>
          </div>

          {/* PANIC ATTACK GROUNDING - Full width between rows */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-blush-50 to-lavender-50 rounded-3xl p-8 md:p-10 shadow-lg border border-blush-100 my-12" data-id="element-1146">
            <div className="text-center mb-6" data-id="element-1147">
              <div className="text-4xl mb-3" data-id="element-1148">🫧</div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-plum-700 mb-2" data-id="element-1149">
                Struggling with a Panic Attack?
              </h2>
              <p className="text-plum-500 font-semibold" data-id="element-1150">
                If you're having anxiety or a panic attack, try this grounding
                technique:
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto" data-id="element-1151">
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1152">
                <span className="text-3xl block mb-3" data-id="element-1153">👀</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1154">
                  See 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1155">
                  Look around and name 5 things you can see right now.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1156">
                <span className="text-3xl block mb-3" data-id="element-1157">✋</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1158">
                  Feel 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1159">
                  Touch 5 different textures — your shirt, the table, your hair.
                </p>
              </div>
              <div className="bg-white/80 rounded-2xl p-6 text-center border border-blush-100 shadow-sm" data-id="element-1160">
                <span className="text-3xl block mb-3" data-id="element-1161">👂</span>
                <h3 className="font-bold text-plum-800 text-lg mb-1" data-id="element-1162">
                  Hear 5 things
                </h3>
                <p className="text-plum-500 font-medium text-sm" data-id="element-1163">
                  Close your eyes and listen for 5 sounds around you.
                </p>
              </div>
            </div>
            <p className="text-cta-500 font-bold text-center mt-6 text-sm italic" data-id="element-1164">
              This helps bring your mind back to the present moment. You're
              going to be okay. 💗
            </p>
          </motion.div>

          {/* GRID ROW 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-1165">
            {/* Card 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-blush-50 rounded-3xl p-8 border border-blush-100 shadow-sm" data-id="element-1166">
              <div className="text-3xl mb-4" data-id="element-1167">🧘‍♀️</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1168">
                Things You Can Do Right Now
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1169">
                <li className="flex items-start gap-2" data-id="element-1170">
                  <span className="text-cta-500 mt-1" data-id="element-1171">•</span> Take a deep
                  breath (seriously—slow it down)
                </li>
                <li className="flex items-start gap-2" data-id="element-1172">
                  <span className="text-cta-500 mt-1" data-id="element-1173">•</span> Drink some water
                </li>
                <li className="flex items-start gap-2" data-id="element-1174">
                  <span className="text-cta-500 mt-1" data-id="element-1175">•</span> Step outside for
                  a few minutes
                </li>
                <li className="flex items-start gap-2" data-id="element-1176">
                  <span className="text-cta-500 mt-1" data-id="element-1177">•</span> Text someone you
                  trust
                </li>
                <li className="flex items-start gap-2" data-id="element-1178">
                  <span className="text-cta-500 mt-1" data-id="element-1179">•</span> Put on music that
                  grounds you
                </li>
              </ul>
            </motion.div>

            {/* Card 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-lavender-50 rounded-3xl p-8 border border-lavender-100 shadow-sm" data-id="element-1180">
              <div className="text-3xl mb-4" data-id="element-1181">📓</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1182">
                Quick Reset Questions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1183">
                <li className="flex items-start gap-2" data-id="element-1184">
                  <span className="text-cta-500 mt-1" data-id="element-1185">•</span> What am I feeling
                  right now?
                </li>
                <li className="flex items-start gap-2" data-id="element-1186">
                  <span className="text-cta-500 mt-1" data-id="element-1187">•</span> What do I
                  actually need today?
                </li>
                <li className="flex items-start gap-2" data-id="element-1188">
                  <span className="text-cta-500 mt-1" data-id="element-1189">•</span> What's one small
                  thing I can do?
                </li>
              </ul>
            </motion.div>

            {/* Card 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-sky-50 rounded-3xl p-8 border border-sky-100 shadow-sm" data-id="element-1190">
              <div className="text-3xl mb-4" data-id="element-1191">🎧</div>
              <h3 className="font-heading text-2xl font-bold text-plum-700 mb-4" data-id="element-1192">
                My Go-To Distractions
              </h3>
              <ul className="space-y-3 text-plum-600 font-medium" data-id="element-1193">
                <li className="flex items-start gap-2" data-id="element-1194">
                  <span className="text-cta-500 mt-1" data-id="element-1195">•</span> A comfort show
                  (Gilmore Girls, anyone?)
                </li>
                <li className="flex items-start gap-2" data-id="element-1196">
                  <span className="text-cta-500 mt-1" data-id="element-1197">•</span> A podcast that
                  feels like talking to a friend
                </li>
                <li className="flex items-start gap-2" data-id="element-1198">
                  <span className="text-cta-500 mt-1" data-id="element-1199">•</span> Scrolling through
                  travel TikToks
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
}